import cx from 'classnames';

type Props = {
  className?: string;
};

export const Divider = ({ className }: Props): JSX.Element => {
  return <div className={cx(className, 'border-t border-black/16')} />;
};
